import React, { useState } from "react";
import parse from "html-react-parser";

const HeyLimeTerms = ({ terms_url, terms_text, setIsLoading }) => {
  const [termsModal, setTermsModal] = useState(false);
  const [termsContent, setTermsContent] = useState("");

  const handleClickTerms = () => {
    if (termsContent === "") {
      setIsLoading(true);
      fetch(terms_url)
        .then((response) => {
          return response.text();
        })
        .then((html) => {
          setTermsContent(html);
          setTermsModal(true);
          setIsLoading(false);
        })
        .catch((err) => setIsLoading(false));
    } else {
      setTermsModal(true);
    }
  };

  return (
    <>
      <p className="heylime-bottom-text">
        {terms_text}
        <span className="terms-text" onClick={handleClickTerms}>
          Terms
        </span>
      </p>
      {termsModal && (
        <div className="invalid-code-modal terms">
          <div className="modal-inner terms">
            <div className="terms-container">{parse(termsContent)}</div>
            <button
              onClick={() => setTermsModal(false)}
              className="try-again-btn terms"
            >
              Okay, I got it!
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default HeyLimeTerms;
